module.exports = __webpack_public_path__ + "static/media/search-lyrics.6af4dbe4.png";